/**
 * Brand Service
 * Business logic for brand and category management
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Brand Service
 * Handles brand fetching and business logic
 */
export class BrandService {
    constructor(brandAPI, offerAPI) {
        this.brandAPI = brandAPI;
        this.offerAPI = offerAPI;
    }
    /**
     * Get brands by category ID
     */
    getBrandsByCategory(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.brandAPI.fetchBrandsByCategoryId(categoryId);
        });
    }
    /**
     * Get brands with their offers for a category
     * Filters out brands with no offers
     */
    getBrandsWithOffers(categoryId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            // Fetch all brands for the category
            const brands = yield this.brandAPI.fetchBrandsByCategoryId(categoryId);
            // Fetch offers for each brand in parallel
            const brandsWithOffers = yield Promise.all(brands.map((brand) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const offers = yield this.offerAPI.fetchOffersByBrandId(brand.id, token);
                    return { brand, offers };
                }
                catch (error) {
                    console.error(`Error fetching offers for brand ${brand.id}:`, error);
                    return { brand, offers: [] };
                }
            })));
            // Filter out brands with no offers
            return brandsWithOffers.filter((item) => item.offers.length > 0);
        });
    }
    /**
     * Generate signup link for a brand
     */
    generateSignupLink(brand, callbackUrl) {
        const baseUrl = brand.shopifyStoreUrl || brand.websiteUrl || "";
        if (!baseUrl)
            return "#";
        const url = new URL(baseUrl);
        url.searchParams.append("meprotocol_callback", callbackUrl);
        return url.toString();
    }
    /**
     * Format conversion rate display
     */
    formatConversionRate(brand) {
        const { rewardSymbol, rewardValueInDollars } = brand.rewardDetails.rewardInfo;
        const dollars = parseFloat(rewardValueInDollars || "0");
        return `1 ${rewardSymbol} = $${dollars.toFixed(2)}`;
    }
    /**
     * Get reward amount display text
     */
    getRewardAmountText(brand) {
        const rule = brand.rewardDetails.rules[0];
        if (!rule)
            return "N/A";
        const { points } = rule;
        const { rewardSymbol } = brand.rewardDetails.rewardInfo;
        return `${points.toLocaleString()} ${rewardSymbol}`;
    }
}
